import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";

const field = "mt-2 h-12 w-full rounded-xl border border-navy/20 bg-ivory px-4 text-[16px] text-navy outline-none focus:border-copper";

const describe = (order) => {
  if (order.shipping_email_sent_at) return "Il cliente ha già ricevuto l'email di spedizione: aggiornerai solo i dati nel pannello.";
  if (!order.customer_email) return "Questo ordine non ha un indirizzo email: nessuna email verrà inviata.";
  return `Invieremo un'email a ${order.customer_email} per avvisare che il pacco è partito. Corriere e numero sono facoltativi.`;
};

export const ShipDialog = ({ order, open, onOpenChange, onConfirm, saving }) => {
  const [carrier, setCarrier] = useState("");
  const [tracking, setTracking] = useState("");

  useEffect(() => {
    if (open) {
      setCarrier(order.carrier ?? "");
      setTracking(order.tracking_number ?? "");
    }
  }, [open, order.carrier, order.tracking_number]);

  const submit = (e) => {
    e.preventDefault();
    onConfirm({ status: "shipped", carrier, tracking_number: tracking });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-md rounded-3xl border-copper/20 bg-cream p-7 sm:p-8" data-testid="ship-dialog">
        <DialogTitle className="pr-6 font-display text-3xl font-medium text-navy">
          Spedisci l'ordine {order.session_id.slice(-8).toUpperCase()}
        </DialogTitle>
        <DialogDescription className="text-[15px] leading-relaxed text-slate2" data-testid="ship-dialog-note">{describe(order)}</DialogDescription>
        <form onSubmit={submit} className="mt-2 space-y-5">
          <label className="block text-[15px] font-medium text-navy">
            Corriere <span className="font-normal text-slate2">(facoltativo)</span>
            <input value={carrier} onChange={(e) => setCarrier(e.target.value)} maxLength={60} placeholder="Nome del corriere" className={field} data-testid="ship-carrier-input" />
          </label>
          <label className="block text-[15px] font-medium text-navy">
            Numero di tracciamento <span className="font-normal text-slate2">(facoltativo)</span>
            <input value={tracking} onChange={(e) => setTracking(e.target.value)} maxLength={80} placeholder="Codice della spedizione" className={field} data-testid="ship-tracking-input" />
          </label>
          <div className="flex flex-col-reverse gap-3 pt-2 sm:flex-row sm:justify-end">
            <button type="button" onClick={() => onOpenChange(false)} data-testid="ship-cancel" className="h-12 rounded-full border border-navy/20 px-6 text-[15px] text-navy transition-colors hover:bg-sand">
              Annulla
            </button>
            <button type="submit" disabled={saving} data-testid="ship-confirm" className="h-12 rounded-full bg-navy px-6 text-[15px] font-medium text-ivory transition-opacity disabled:opacity-40">
              {saving ? "Salvo…" : order.fulfillment_status === "shipped" ? "Salva i dati" : "Segna come spedito"}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
